import { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './VerificacionEmail.css';

function VerificacionEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verificando');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();
  const ejecutado = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMensaje('No se proporcionó un token de verificación.');
      return;
    }

    if (ejecutado.current) return;
    ejecutado.current = true;

    const verificarEmail = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';
        console.log('🔍 Verificando token:', token);
        const response = await fetch(`${API_URL}/api/v1/auth/verificar?token=${token}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        console.log('📡 Respuesta HTTP:', response.status);

        if (response.ok) {
          const data = await response.json();
          setStatus('exito');
          setMensaje(data.mensaje || '¡Email verificado correctamente! Ya puedes iniciar sesión.');
        } else {
          const error = await response.json();
          setStatus('error');
          setMensaje(error.detail || 'Error al verificar el email. El token puede haber expirado o ya fue usado.');
        }
      } catch (error) {
        console.error('❌ Error de conexión:', error);
        setStatus('error');
        setMensaje('Error de conexión. Intenta nuevamente más tarde.');
      }
    };

    verificarEmail();
  }, [token]);

  return (
    <div className="verificacion-container">
      <div className="verificacion-card">
        {status === 'verificando' && (
          <>
            <div className="verificacion-spinner"></div>
            <h2>Verificando tu email...</h2>
            <p>Por favor espera, estamos activando tu cuenta.</p>
          </>
        )}
        
        {status === 'exito' && (
          <>
            <div className="verificacion-icon success">✓</div>
            <h2>¡Cuenta activada!</h2>
            <p>{mensaje}</p>
            <button className="verificacion-btn" onClick={() => navigate('/login')}>
              Ir al inicio de sesión
            </button>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="verificacion-icon error">✗</div>
            <h2>Error de verificación</h2>
            <p>{mensaje}</p>
            <button className="verificacion-btn" onClick={() => navigate('/login')}>
              Volver al inicio
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default VerificacionEmail;